import { render } from "./BillDetail.vue?vue&type=template&id=988453d8&scoped=true"
import script from "./scripts/bill-detail.ts?vue&type=script&language=ts&lang=js"
export * from "./scripts/bill-detail.ts?vue&type=script&language=ts&lang=js"

import "./BillDetail.vue?vue&type=style&index=0&id=988453d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-988453d8"]])

export default __exports__